import { CustomTable } from "_components/table/CustomTable";
import { contextActions } from "_store";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

export { AlertsSidePanelTableViariables }

function AlertsSidePanelTableViariables ({showType = true, maxHeight = '300px'}) {

    const [tableData, setTableData] = useState([]);
    let headers = [];
    const contextDetails = useSelector(state => state.contextDetails);
    const data = useSelector((state) => state.sidePanel?.data);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!contextDetails.data && !contextDetails.isLoading){
            dispatch(contextActions.getContextDetail())
        }
    }, [contextDetails])

    /* Préparation des données à afficher */
    useEffect(() => {
        if (data?.CONTEXT && contextDetails.data) {
            const context = data?.CONTEXT;
            // Fonction pour extraire l'unité de la description
            function extractUnit(description) {
                const unitMatch = description.match(/\[(.*?)\]/);
                return unitMatch ? unitMatch[1] : null;
            }

            // Fonction pour remplacer la valeur par sa description si applicable
            function replaceValueWithDescription(value, unit) {
                if (unit) {
                    const unitMap = unit.split(';').map(item => item.split(':').map(s => s.trim()));
                    const unitObj = Object.fromEntries(unitMap);
                    return unitObj[value] || `${value}${unit}`;
                }
                return value;
            }

            // Construire le tableau
            const table = Object.keys(context).map(key => {
                const value = context[key];
                const detail = contextDetails.data[key] || {};
                const description = detail.description ? detail.description.replace(/\[.*?\]/, '').trim() : 'No description';
                const unit = extractUnit(detail.description);
                const formattedValue = unit && unit.includes(':') ? replaceValueWithDescription(value, unit) : `${value}${unit || ''}`;
                
                return {
                    type: data.HEADER_TYPE,
                    label: description,
                    key: key,
                    value: formattedValue,                    
                    unit: unit
                };
            });
            setTableData(table)
        }

    }, [data, contextDetails])

    if (showType) {
        headers = [
            { label: 'Type', key: 'type', type: 'string', canToggle: false, visible: true},
            { label: 'Libellé', key: 'label', type: 'string', canToggle: false, visible: true },
            { label: 'Valeur', key: 'value', type: 'string', canToggle: false, visible: true },
        ]    
    } else {
        headers = [
            { label: 'Libellé', key: 'label', type: 'string', canToggle: false, visible: true },
            { label: 'Valeur', key: 'value', type: 'string', canToggle: false, visible: true },
        ]    
    }
   

    return (
        <div className="side-panel-custom-table">
            <div className={'flex justify-between items-center'}>
                <div className={'xsmall-title-customtable'}>
                    Variables contextuelles
                </div>
            </div>
            <div >
                <CustomTable data={tableData} headers={headers} maxHeight={maxHeight}/>
            </div>
        </div>
    )
}